import { Row, Col, Container } from "react-bootstrap";
import { MockTimetracking } from "../../../Public/Landingpages/Components/MockScreens";

const TimetrackingLandingpage = () => {
  return (
    <>
      <div className="lp-section-alt">
        <Container>
          <Row className="align-items-center" style={{ paddingTop: "4.5rem", paddingBottom: "4.5rem", position: "relative" }}>
            <Col className="yellowdotWelcome" />
            <Col className="greendotWelcome" />
            <Col md={6} sm={12} style={{ marginBottom: "1.5rem" }}>
              <div className="blueSubheaderTop">Time Tracking</div>
              <div className="landingpageHeader" style={{ fontWeight: "500", lineHeight: "120%", marginTop: "0.5rem" }}>
                Be transparent with your customer
              </div>
              <p className="landingpageDescriptions">
                Produce standardized timesheets ready to sign off for your
                clients. Coming up: separate time-tracking per ticket and direct
                customer timesheet approval.
              </p>
            </Col>
            <Col md={6} sm={12}>
              <Col className="reddotWelcome" />
              <MockTimetracking />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default TimetrackingLandingpage;
